import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './estilos/global.css';
import { destinoNoCelular, escolhaDaMesa } from './lib/celular';
import { aplicarTemaSalvo } from './lib/tema';

aplicarTemaSalvo();

/* O telefone que abre a tela de computador vai para o app (`lib/celular.ts`),
   antes de montar qualquer coisa: a primeira pintura já é a do app. */
const noApp = destinoNoCelular(window.location.pathname, window.navigator.userAgent, escolhaDaMesa(window.location.search));
if (noApp) window.location.replace(`${noApp}${window.location.hash}`);

const raiz = document.getElementById('raiz');
if (!raiz) {
  throw new Error('O elemento #raiz não existe no index.html. A aplicação não tem onde montar.');
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
